
import store from '../../config/store'
import axios from '../../http'

export default {

  data: () => ({
    store,
    url: store.modal.dataModel.url,
    isLocal: !!store.modal.dataModel.isLocal
  }),

  methods: {

    /**
     * onDelete
     */
    onDelete () {
      if (this.isLocal) {
        this.$bus.$emit('delete-local-file')
        this.close()
      } else {
        axios.delete(this.url).then(this.onDeleteSuccess, this.onDeleteFailure)
      }
    },

    /**
     * onDeleteSuccess
     */
    onDeleteSuccess () {
      this.$bus.$emit('delete-success')
      this.close()
    },

    /**
     * onDeleteFailure
     */
    onDeleteFailure () {
      this.$bus.$emit('delete-failure')
    },

    /**
     * close
     */
    close () {
      store.modal.active = false
    }
  }
}
